import { getImageUrl } from "../../helpers/getImageUrl";
import { getFrontendUrl } from "../../helpers/utils";
import { Serie } from "../../types/Serie";

export function getRichSnippet(series: Serie) {
  const common = {
    "@type": "CreativeWorkSeries",
    "@id": getFrontendUrl(`/#series/${series.slug}`),
    name: series.name,
    url: getFrontendUrl(`/series/${series.slug}`),
    image: getImageUrl(series.featured_image),
    genre: series.genre,
    description: series.description,
    keywords: series.keywords,
    about: series.about,
    accessMode: "visual",
    author: {
      "@id": getFrontendUrl("/#person")
    },
    contentLocation: {
      name: series.location
    },
    copyrightHolder: series.copyright_holder,
    copyrightYear: new Date(series.copyright_year).getFullYear(),
    creativeWorkStatus: "Published",
    datePublished: new Date(series.published_date).toISOString(),
    isFamilyFriendly: series.family_friendly
  };

  return common;
}
